import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { InvoicesSettingsPageContext } from "./InvoicesSettingsPageContext";

export const useInvoicesSettingsPageContext = () => {
  const context = useContext(InvoicesSettingsPageContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useInvoicesSettingsPageContext",
      "InvoicesSettingsPageContext"
    );
  }

  return context;
};
